// removed by extract-text-webpack-plugin
module.exports = {"modal":"ModalAddToCart-module__modal___3ndH8","modal__body":"ModalAddToCart-module__modal__body___2HrxQ","modal__title":"ModalAddToCart-module__modal__title___2rNM8","modal__content":"ModalAddToCart-module__modal__content___12exR","modal__actions":"ModalAddToCart-module__modal__actions___1Ki1C","modal__link":"ModalAddToCart-module__modal__link___385TF","modal__link__primary":"ModalAddToCart-module__modal__link__primary___3bY1W"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ModalAddToCart/ModalAddToCart.module.css
// module id = 634
// module chunks = 0